import $ from "../../jquery_global"

// 経験あり → 知識あり 自動チェック
$(function () {
  $(document).on('change', 'input[data-role="experience-id"]', function () {
    if (!this.checked) return // 外したときは knowledge を触らない（手動操作優先）
    var experienceId = this.dataset.experienceId
    if (!experienceId) return
    var $knowledge = $('input[data-role="knowledge-id"][data-experience-id="' + experienceId + '"]')
    if ($knowledge.length && !$knowledge.prop('checked')) {
      $knowledge.prop('checked', true)
    }
  })
})

// 在学状況の表示出しわけ
$(function () {
  var SELECT_SELECTOR = '[data-role="enroll-status"]'

  var SECTIONS = {
    graduateYear: '#edit-profile-schoolhistory-field-graduate-year',
    schoolingYear: '#edit-profile-schoolhistory-field-schooling-year',
    schoolName: '#edit-profile-schoolhistory-field-school-name',
    faculty: '#edit-profile-schoolhistory-field-faculty',
    department: '#edit-profile-schoolhistory-field-department'
  }

  var SHOW_MAP = {
    nothing: [],
    already_graduated: [SECTIONS.graduateYear, SECTIONS.schoolName, SECTIONS.faculty, SECTIONS.department],
    enrolled_in_school: [SECTIONS.graduateYear, SECTIONS.schoolingYear, SECTIONS.schoolName, SECTIONS.faculty, SECTIONS.department]
  }

  function applyVisibility() {
    var $select = $(SELECT_SELECTOR)
    if ($select.length === 0) return
    var v = $select.val()
    var visibleSelectors = SHOW_MAP[v] || []
    Object.keys(SECTIONS).forEach(function (key) {
      var selector = SECTIONS[key]
      $(selector).toggle(visibleSelectors.indexOf(selector) !== -1)
    })
  }

  applyVisibility()
  $(document).on('change', SELECT_SELECTOR, applyVisibility)
})
